/**
 * Icon — KPI картын иконууд. Гараар зурсан inline SVG.
 *
 * ⚠️ ИКОНЫ САН НЭМЭХГҮЙ. `lucide-react` гэх сан 11 иконд ~5 KB gzip
 *    нэмнэ (энэ файл ~0.7 KB), мөн төсөлд аль хэдийн байгаа гурван
 *    гар зурсан икон (`app-shell` цэс, `theme-toggle` сар/нар,
 *    `empty-state` анхааруулга) -тай зэрэгцээ ХОЁР систем үүсгэнэ.
 *    Босго: 30+ икон хэрэгтэй болбол (сайдбарын цэс) дахин ярина.
 *
 * Тэдгээр гурвын хэв маягтай яг нийцнэ: 16px хайрцаг,
 * `stroke="currentColor"`, `strokeWidth` 1.4, `aria-hidden`.
 * Өнгө нь эцгээсээ `currentColor`-оор ирнэ — энд hex бичихгүй.
 *
 * ⚠️ Брэндийн цаа бугын дүрс ЭНД ОРОХГҮЙ. Тэр нь лого, өөрийн
 *    өнгөтэй (`--color-brand`) бөгөөд `/logo.svg`-ээр л хэрэглэгдэнэ.
 *
 * ⚠️ `chart` дээр СУМ БАЙХГҮЙ — зөвхөн багана. Иконы сум нь «өсөх =
 *    сайн» гэж уншигдана, харин `StatCard` нь яг тэр төөрөгдлөөс
 *    сэргийлж `delta.good`-оор өнгө сонгодог (рублийн ханш өсөх нь
 *    МУУ мэдээ). Хоёр дохио зөрчилдөх ёсгүй.
 */

import type { ReactNode } from 'react';

const PATHS = {
  /**
   * Нэгж — `Item` = нэг биет гутал.
   *
   * ⚠️ ЭНЭ НЬ ГУТЛЫН ДҮРС БАЙХ ЁСТОЙ БАЙСАН. Хоёр оролдлого хийсэн:
   *      1) `M4 2.7h3.2v5.6l3.6 1.6a2 2 0 0 1 1.2 1.8v1.4H4z`
   *      2) `M3.6 2.4h3.6v6.1h2.2a3 3 0 0 1 3 3v2H3.6z`  (өлмий зузаан)
   *    Хоёул 16px дээр бяцхан «L» үсэг шиг уншигдсан: түрий+өлмий
   *    хоёрын өнцөг 1.4 зурваст нийлж, гутлын хэлбэр алга болно.
   *    Хажуугийн бусад икон (store, truck, warehouse) шууд танигддаг
   *    тул зөвхөн энэ нэг нь бүдэг байх нь дордуулна. Тиймээс
   *    гурав дахь оролдлого хийхгүй, ил тод `box` руу шилжсэн.
   *    Дахин оролдох бол дээрх хоёр зам эхлэлийн цэг болно.
   */
  box: (
    <>
      <path d="M2.6 5 8 2.2 13.4 5v6L8 13.8 2.6 10.8z" />
      <path d="M2.6 5 8 7.8l5.4-2.8M8 7.8v6" />
    </>
  ),

  /** Дэлгүүр — БИЕЭСЭЭ ӨРГӨН саравч + хаалга.
      Саравч нь ханаас цухуйж байж «дэлгүүрийн нүүр» гэж уншигдана;
      биетэйгээ тэнцүү бол дискет шиг харагдана. Агуулахын ХАЗГАЙ
      дээвэртэй хосоороо ялгаатай (staff хуудсанд хоёул зэрэг гарна). */
  store: (
    <>
      <path d="M2 6.4h12l-1.3-3.3H3.3z" />
      <path d="M3.1 6.4v7.1h9.8V6.4" />
      <path d="M6.5 13.5v-3.4h3v3.4" />
    </>
  ),

  /** Агуулах — ХАЗГАЙ дээвэр + хаалга (дэлгүүрээс ялгах гол шинж) */
  warehouse: (
    <>
      <path d="M2.2 6.9 8 3.1l5.8 3.8v6.6H2.2z" />
      <path d="M6.2 13.5V9.7h3.6v3.8" />
    </>
  ),

  /** Ачаа тээвэр — Оросоос ирэх аялал, шилжүүлэг */
  truck: (
    <>
      <path d="M1.9 4.4h6.9v6.9H1.9z" />
      <path d="M8.8 6.7h2.5l2.8 2.6v2H8.8z" />
      <circle cx="4.9" cy="12.4" r="1.1" />
      <circle cx="11.4" cy="12.4" r="1.1" />
    </>
  ),

  /** Баримт — борлуулалт, захиалга */
  receipt: (
    <>
      <path d="M3.6 2.5h8.8v11l-1.47-1-1.47 1-1.46-1-1.47 1-1.46-1-1.47 1z" />
      <path d="M6 5.9h4M6 8.7h4" />
    </>
  ),

  /** Зоос — мөнгө, өртөг, дүн.
      Нүүрээрээ харсан хоёр зоос. ⚠️ Босоо давхарласан цилиндр
      (эхний оролдлого) нь өндөр нарийхан тул өгөгдлийн САН шиг
      уншигдаж байсан — тэр хэлбэрт буцаж болохгүй. */
  coins: (
    <>
      <circle cx="6" cy="6.2" r="3.7" />
      <circle cx="10" cy="9.8" r="3.7" />
    </>
  ),

  /** Өсөх багана — СУМГҮЙ (файлын толгойд шалтгаан нь бий) */
  chart: <path d="M3.6 13.4V9.2M8 13.4V5.9M12.4 13.4V2.9" />,

  /** Хувь — урамшуулал */
  percent: (
    <>
      <path d="M3.4 12.6 12.6 3.4" />
      <circle cx="4.9" cy="4.9" r="1.7" />
      <circle cx="11.1" cy="11.1" r="1.7" />
    </>
  ),

  /** Хүмүүс — ажилтан, нийлүүлэгч */
  users: (
    <>
      <circle cx="6.3" cy="5.2" r="2.3" />
      <path d="M2.2 13.3c0-2.2 1.84-3.5 4.1-3.5s4.1 1.3 4.1 3.5" />
      <path d="M11 3.3a2.3 2.3 0 0 1 0 3.9M12 10c1.14.44 1.8 1.4 1.8 3.3" />
    </>
  ),

  /** Синк — хоёр сум. Орост үлдсэн бичлэг ирсэн эсэх */
  sync: (
    <>
      <path d="M13.3 7.1A5.5 5.5 0 0 0 4 4.4L2.4 6" />
      <path d="M2.4 2.8V6h3.2" />
      <path d="M2.7 8.9a5.5 5.5 0 0 0 9.3 2.7l1.6-1.6" />
      <path d="M13.6 13.2V10h-3.2" />
    </>
  ),

  /** Байршил — Оросод ажиллаж буй цуглуулагч */
  pin: (
    <>
      <path d="M8 13.8s4.4-4.1 4.4-7.2a4.4 4.4 0 1 0-8.8 0c0 3.1 4.4 7.2 4.4 7.2z" />
      <circle cx="8" cy="6.5" r="1.7" />
    </>
  ),
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof PATHS;

export function Icon({ name }: { name: IconName }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
